/**
 * Fee configuration modules using the createCrudApi factory.
 * feeSchedule, labTest, procedure, medicineItem, samples.
 */
import { fetchApi, API_BASE_URL } from '../client';
import { createCrudApi } from '../helpers';

// Strip sentinel UI values before sending to backend
const feeScheduleFilters = (f: any) => ({
  department: f?.department !== 'All Departments' ? f?.department : undefined,
  feeType: f?.feeType !== 'All Types' ? f?.feeType : undefined,
  status: f?.status !== 'All' ? f?.status : undefined,
  search: f?.search,
  page: f?.page,
  pageSize: f?.pageSize,
});

const labTestFilters = (f: any) => ({
  category: f?.category !== 'All Categories' ? f?.category : undefined,
  feeType: f?.feeType !== 'All Types' ? f?.feeType : undefined,
  status: f?.status !== 'All' ? f?.status : undefined,
  search: f?.search,
  page: f?.page,
  pageSize: f?.pageSize,
});

const procedureFilters = (f: any) => ({
  department: f?.department !== 'All Departments' ? f?.department : undefined,
  status: f?.status,
  search: f?.search,
  page: f?.page,
  pageSize: f?.pageSize,
});

const medicineFilters = (f: any) => ({
  category: f?.category !== 'All Categories' ? f?.category : undefined,
  status: f?.status,
  search: f?.search,
  page: f?.page,
  pageSize: f?.pageSize,
});

export const feeScheduleModule = {
  ...createCrudApi('/api/fee-schedules', feeScheduleFilters),
  getDefault: (visitType: string) =>
    fetchApi<any>(`/api/fee-schedules/defaults?visitType=${encodeURIComponent(visitType)}`),
};

export const labTestModule = createCrudApi('/api/lab-tests', labTestFilters);

export const procedureModule = createCrudApi('/api/procedures', procedureFilters);

export const medicineItemModule = createCrudApi('/api/medicine-items', medicineFilters);

export const samplesModule = {
  downloadConsultationFees: () => { window.location.href = `${API_BASE_URL}/api/samples/consultation-fees`; },
  downloadLabTests: () => { window.location.href = `${API_BASE_URL}/api/samples/lab-tests`; },
  downloadMedicineItems: () => { window.location.href = `${API_BASE_URL}/api/samples/medicine-items`; },
  downloadProcedures: () => { window.location.href = `${API_BASE_URL}/api/samples/procedures`; },
};
